/**
 * Categorical Rhyme Detection Types
 * 7 discrete, mutually exclusive rhyme categories with fixed weights
 */

/**
 * 7 Rhyme Categories - DISCRETE and MUTUALLY EXCLUSIVE
 * Detection follows strict priority order with short-circuit evaluation
 */
export enum RhymeCategory {
  PERFECT = 'PERFECT',                    // Weight: 1.0
  FAMILY_VOICED = 'FAMILY_VOICED',        // Weight: 0.85
  FAMILY_UNVOICED = 'FAMILY_UNVOICED',    // Weight: 0.75
  ADDITIVE = 'ADDITIVE',                  // Weight: 0.70
  SUBTRACTIVE = 'SUBTRACTIVE',            // Weight: 0.70
  ASSONANCE = 'ASSONANCE',                // Weight: 0.50
  CONSONANCE = 'CONSONANCE',              // Weight: 0.40
  NONE = 'NONE'                           // Weight: 0.0
}

/**
 * Fixed weights for each rhyme category
 * No confidence scores - each category has exactly one weight
 */
export const CATEGORY_WEIGHTS: Record<RhymeCategory, number> = {
  [RhymeCategory.PERFECT]: 1.0,
  [RhymeCategory.FAMILY_VOICED]: 0.85,
  [RhymeCategory.FAMILY_UNVOICED]: 0.75,
  [RhymeCategory.ADDITIVE]: 0.70,
  [RhymeCategory.SUBTRACTIVE]: 0.70,
  [RhymeCategory.ASSONANCE]: 0.50,
  [RhymeCategory.CONSONANCE]: 0.40,
  [RhymeCategory.NONE]: 0.0,
};

/**
 * Structured rhyme match result
 * Replaces legacy confidence-based outputs
 */
export interface RhymeMatch {
  category: RhymeCategory;
  weight: number;  // From CATEGORY_WEIGHTS
  word1: string;
  word2: string;
  phonemes1: string[];
  phonemes2: string[];
}
